export default __webpack_public_path__ + "static/media/chatbg.bded4f44.png";